export const namespacedPrefix = '[SEMIS]';
